import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { Container } from 'reactstrap'
import Redirect from 'react-router-dom/Redirect'
import Components from '../components'

const HOME_NAME = 'VPPGamingNetwork'

export class HomeNavigator extends React.Component {
  componentWillMount() {
    document.title = HOME_NAME
  }

  render() {
    return (
      <Container fluid>
        <Components.partials.Header />
        <Switch>
          <Route exact path={'/'} component={Components.Home} />
          <Route exact path={'/games'} component={Components.Games} />
          <Route exact path={'/info'} component={Components.Info} />
          <Route exact path={'/payments'} component={Components.Rates} />
          <Route exact path={'/partners'} component={Components.Partners} />
          <Route exact path={'/privacy'} component={Components.Privacy} />
          <Route exact path={'/terms'} component={Components.Terms} />
          <Route exact path={'/about'} component={Components.About} />
          <Route
            exact
            path={'/advertisers'}
            component={Components.Advertisers}
          />
          <Route exact path={'/contact'} component={Components.Contact} />
          <Redirect to="/" />
        </Switch>
        <Components.partials.Footer />
      </Container>
    )
  }
}

export default HomeNavigator



// WEBPACK FOOTER //
// ./src/navigators/Home.js